import React, { useContext, useState, useRef, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LogIn, User, Key, Settings, ChevronUp } from "lucide-react";
import CustomizerContext from "../../_helper/Customizer";
import { useAuth } from "../../app/AuthProvider";
import styles from "./SidebarProfile.module.scss";

// Sidebar alt profil bloğu (header'dan TAŞINDI — sahip feedback'i). Avatar + ad/rol;
// tıklayınca menü YUKARI açılır (footer altta olduğu için). Rail'de yalnız avatar.
// Menü öğeleri eski header UserHeader ile birebir (profil/şifre/tercih/çıkış).
const SidebarProfile = () => {
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const { layoutURL } = useContext(CustomizerContext);
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const displayName = user?.name || "Zehra Ecer";
  const initials = displayName
    .trim()
    .split(/\s+/)
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  // Dışarı tıkla / Esc → kapat.
  useEffect(() => {
    if (!open) return undefined;
    const onPointer = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false);
    };
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onPointer);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onPointer);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const go = useCallback(
    (path, state = {}) => {
      navigate(path, { state });
      setOpen(false);
    },
    [navigate]
  );

  const logout = useCallback(async () => {
    await signOut();
    navigate(`${""}/login`);
  }, [signOut, navigate]);

  const menu = [
    {
      key: "profile",
      icon: User,
      label: t("My Profile"),
      onClick: () =>
        go(`${""}/users/profile/1/${layoutURL}?tabId=1`, {
          user: { type: "user" },
        }),
    },
    {
      key: "password",
      icon: Key,
      label: t("Change Password"),
      onClick: () =>
        go(`${""}/users/profile/1/${layoutURL}?tabId=5`, {
          user: { type: "user" },
        }),
    },
    {
      key: "prefs",
      icon: Settings,
      label: t("My Preferences"),
      onClick: () =>
        go(`${""}/users/profile/1/${layoutURL}?tabId=6`, {
          user: { type: "user" },
        }),
    },
  ];

  return (
    <div
      className={`${styles.profile} ${open ? styles.open : ""}`}
      ref={rootRef}
    >
      <button
        type="button"
        className={styles.trigger}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
        title={displayName}
      >
        {user?.avatar ? (
          <img className={styles.avatar} src={user.avatar} alt="" />
        ) : (
          <span className={styles.avatarFallback} aria-hidden="true">
            {initials}
          </span>
        )}
        <span className={styles.meta}>
          <span className={styles.name}>{displayName}</span>
          <span className={styles.role}>{t("Admin")}</span>
        </span>
        <ChevronUp className={styles.caret} size={16} />
      </button>

      {open && (
        <div className={styles.menu} role="menu">
          {menu.map(({ key, icon: Icon, label, onClick }) => (
            <button
              key={key}
              type="button"
              role="menuitem"
              className={styles.item}
              onClick={onClick}
            >
              <Icon size={16} />
              <span>{label}</span>
            </button>
          ))}
          <div className={styles.divider} />
          <button
            type="button"
            role="menuitem"
            className={`${styles.item} ${styles.danger}`}
            onClick={logout}
          >
            <LogIn size={16} />
            <span>{t("Sign Out")}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default SidebarProfile;
